// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
			//suggestionMode: 'test',
			//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	InstantSearchMobile.prototype.afterShowSearchBoxMobile = function(searchBoxId) {
		if (!searchBoxId) searchBoxId = this.searchBoxId;
		// Hide debut's search bar on mobile, and show our search bar instead
		// setTimeout(function() {
		// 	jQ('.js-drawer-close').trigger('click');
		// });

		window.closeDrawers();
		
		$('body').addClass('disable-scroll');
	};

	SearchInput.prototype.customizeInstantSearch= function() {
		// Hide debut's search suggestion
		if (jQ('.predictive-search-wrapper').length > 0){
				jQ('.predictive-search-wrapper').hide();
		}
	};

	function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
		/* console.log('closeSuggestionMobile'); */
		jQ(searchBoxId).autocomplete('close');
		jQ('.' + Class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
		// Remove search box
		var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
		if (isCloseSearchBox) jQ('.boost-pfs-search-suggestion-mobile-top-panel,.boost-pfs-search-suggestion-mobile-overlay').hide();
		// Update current term for all search boxes
		setValueAllSearchBoxes();
		// Add back tabindex=-1
		jQ('.boost-pfs-search-no-tabindex').attr('tabindex', -1);
		// Return scrolling of body
		if(jQ('body').hasClass(Class.searchSuggestionMobileOpen)){    
			jQ('body').removeClass(Class.searchSuggestionMobileOpen);
		}
		BoostPFS.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);
	
		// Close search theme debut
		if(jQ('.js-drawer-close').length > 1){
			jQ('.js-drawer-close').trigger('click');
		}
	}

	var instantSearchTemplate = InstantSearchResultBlock.prototype.getTemplate;

	InstantSearchResultBlock.prototype.getTemplate = function(tempType) {
		if (['products', 'collections'].indexOf(tempType) === -1) return instantSearchTemplate.call(this, tempType);

		return '<li class="{{class.searchSuggestionGroup}} ' + tempType + '" data-group="{{type}}" aria-label="{{label}}">' +
			'<ul class="default">' +
			'<li class="{{class.searchSuggestionHeader}}-{{type}} {{class.searchSuggestionHeader}}" aria-label="{{label}}">{{label}}</li>' +
			'{{resultItems}}' +
			'</ul>' +
			'</li>';
	}

	InstantSearchResultBlock.prototype.compileTemplate = function() {
		if ((this.status != 'active' || !this.isShow) && !this._isShowDYM()) {
			return '';
		}
		var label = this.isAllEmpty ? this.notFoundLabel : this.label;

		return this.getTemplate(this.type)
			.replace(/{{type}}/g, this.type)
			.replace(/{{label}}/g, label)
			.replace(/{{class.searchSuggestionHeader}}/g, Class.searchSuggestionHeader)
			.replace(/{{class.searchSuggestionGroup}}/g, Class.searchSuggestionGroup)
			.replace(/{{resultItems}}/g, '');
	}

	/**
	 * Render the instant search result block
	 * @returns {Object} jQuery object
	 */
	InstantSearchResultBlock.prototype.render = function() {
		this.$element = jQ(this.compileTemplate());
		var self = this;

		if (['products', 'collections'].indexOf(this.type) !== -1) {
			this.children.forEach(function(child) {
				if (child.$element) {
					
					/*  ---  Your conditional  ---  */					
					
					if (child.data.template_suffix == 'total-look') {
						jQ(child.$element).find('.boost-pfs-search-suggestion-product-price').html('<span class="boost-pfs-search-suggestion-product-regular-price hide"></span>');
						self.$element.find('> ul.default').append(child.$element);
					} else {
						self.$element.find('> ul.default').append(child.$element);
					}

					/*  --- end of Your conditional  ---  */

				}
			})
			if (self.$element.find('ul.default').children().length <= 1) {
				self.$element.find('ul.default').remove()
			}
			if (self.$element.find('ul.default').children().length <= 1) {
				self.$element.find('ul.default').remove()
			}
		} else {
			this.children.forEach(function(child) {
				if (child.$element) {
					self.$element.find('> ul').append(child.$element);
				}
			});
		}
	}
})();